export default {
	MY_OPERATION_TASK_TABLE: 'MyOperationTaskTable',
	DASHBOARD_TASK_SLA_TABLE: 'DashboardTaskSlaTable',
	MY_OPERATION_TASK_TABLE_AVANCED_FILTER: 'MyOperationTaskTableAvancedFilter',
	DASHBOARD_TASK_SUMMARY_FILTER: 'DashboardTaskSummaryFilter',
};
